function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.585 4.492c-1.011 0-1.831.82-1.831 1.831v1.173c.237-.048.482-.074.732-.074h2.93V6.323c0-1.011-.82-1.83-1.831-1.83zM9.29 8.173v-.385a1.831 1.831 0 1 0-3.663 0v5.127c0 1.011.82 1.831 1.831 1.831.69 0 1.267-.396 1.58-.959a3.64 3.64 0 0 1-1.214-2.703c0-1.192.581-2.242 1.465-2.911z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.613 8.887h-5.127a2.197 2.197 0 1 0 0 4.394h4.395a.732.732 0 1 1 0 1.465 3.666 3.666 0 0 0-3.662 3.662v1.465a.732.732 0 1 1-1.465 0v-1.465c0-1.435.596-2.73 1.55-3.662h-2.108a3.294 3.294 0 0 1-3.133 1.442c-1.691-.198-2.9-1.755-2.9-3.458V4.858a1.831 1.831 0 1 0-3.663 0v9.458c0 5.615 4.326 10.51 9.938 10.68 5.807.174 10.57-4.482 10.57-10.25v-1.465a4.395 4.395 0 0 0-4.395-4.394zM17.712 0C16.7 0 15.88.82 15.88 1.831v5.59h.732c1.072 0 2.065.311 2.93.816V1.831C19.543.82 18.723 0 17.712 0z"
}));

var SvgMetal = function SvgMetal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMetal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/metal.62992f38.svg";
export { ForwardRef as ReactComponent };